function getCookie(value: string): string {
  // Disabled detect-non-literal-regexp because this is run client side and RegExp Dos is not a concern
  // nosemgrep
  const re = new RegExp(`(?:(?:^|.*;\\s*)${value}\\s*\\=\\s*([^;]*).*$)|^.*$`)
  return decodeURIComponent(document.cookie.replace(re, '$1'))
}

export default {
  getCookie,
}
